import React from "react";
import classNames from "classnames";
import { TrashIcon } from "@heroicons/react/20/solid";

interface IProps {
  buttonText?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  styles?: {
    buttonColor?: string;
  };
}

export default function DeleteButton({
  onClick,
  buttonText = "Delete",
  className,
  styles = { buttonColor: "red" },
}: IProps) {
  return (
    <button
      type="button"
      className={classNames(
        `text-${styles?.buttonColor}-500 text-xs font-medium flex items-center justify-end w-full px-4`,
        className
      )}
      onClick={onClick}
    >
      <TrashIcon className={`w-4 h-4 text-${styles?.buttonColor}-500 mr-2`} />
      {buttonText}
    </button>
  );
}
